"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapUsers = exports.default = exports.GroupMembersWidget = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _toKebabCase = require("@insided/shared/utils/toKebabCase");

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _GroupMembersModal = _interopRequireDefault(require("./GroupMembersModal"));

var _preactPortal = _interopRequireDefault(require("preact-portal"));

var _service = require("./service");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_CURRENT_PAGE = 1;
var DEFAULT_PAGE_SIZE = 25;

var mapUsers = function mapUsers(members) {
  return members.map(function (member) {
    return {
      id: "".concat(member.id),
      name: member.username,
      avatar: member.avatar,
      url: "/members/".concat((0, _toKebabCase.textToKebab)(member.username), "-").concat(member.id),
      userTitle: member.member_status
    };
  });
};

exports.mapUsers = mapUsers;

var GroupMembersWidget = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupMembersWidget, _Component);

  var _super = _createSuper(GroupMembersWidget);

  function GroupMembersWidget() {
    var _this;

    (0, _classCallCheck2.default)(this, GroupMembersWidget);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      showMembersModal: false,
      membersShortList: [],
      membersTotal: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _yield$fetchMembers, members, total;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0, _service.fetchMembers)({
                groupId: _this.props.group.id,
                page: DEFAULT_CURRENT_PAGE,
                pageSize: DEFAULT_PAGE_SIZE
              });

            case 3:
              _yield$fetchMembers = _context.sent;
              members = _yield$fetchMembers.members;
              total = _yield$fetchMembers.total;

              _this.setState({
                membersShortList: mapUsers(members.slice(0, 5).reverse()),
                membersTotal: total
              });

              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);

              _logger.logger.error(_context.t0, {
                component: 'GroupMembersWidget',
                action: 'componentDidMount'
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "openMembersModal", function () {
      _this.setState({
        showMembersModal: true
      });
    });
    return _this;
  }

  (0, _createClass2.default)(GroupMembersWidget, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var group = this.props.group;
      var _this$state = this.state,
          membersShortList = _this$state.membersShortList,
          membersTotal = _this$state.membersTotal,
          showMembersModal = _this$state.showMembersModal;
      return (0, _preact.h)(_preactPortal.default, {
        key: "members-widget",
        into: ".group-details-page_members-count"
      }, (0, _preact.h)("div", {
        className: "group-moderation__members-widget"
      }, (0, _preact.h)("div", {
        className: "group-moderation__members-widget__members"
      }, membersShortList.map(function (member) {
        return (0, _preact.h)("div", {
          key: member.id,
          className: "group-moderation__members-widget__member"
        }, (0, _preact.h)(_UserAvatar.default, {
          user: member,
          width: 32,
          height: 32,
          avatarBaseSize: "64x64"
        }));
      })), (0, _preact.h)("div", {
        className: "group-moderation__members-widget__info",
        onClick: this.openMembersModal
      }, (0, _preact.h)("span", {
        className: "group-moderation__members-widget__info__count"
      }, membersTotal), ' ', (0, _preact.h)(_phrase.default, {
        p: "groups.group.members"
      })), showMembersModal ? (0, _preact.h)(_GroupMembersModal.default, {
        group: group,
        onClose: function onClose() {
          return _this2.setState({
            showMembersModal: false
          });
        }
      }) : null));
    }
  }]);
  return GroupMembersWidget;
}(_preact.Component);

exports.GroupMembersWidget = GroupMembersWidget;
var _default = GroupMembersWidget;
exports.default = _default;